module.exports = __webpack_public_path__ + "static/inkblot-greenShield-logo-colour-en-b326a483868530a18bc2a7fa0581fd76.png";